import React, { useState } from "react";
import { Button } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { createNewFolder } from "../../../actions";
import { NodeNameDialog } from "./NodeNameDialog";

/**
 * Renders the "Add folder" CTA and handles the modal flow for naming the folder.
 * @returns {JSX.Element}
 */
export function AddFolderButton() {
	const [showDialog, setShowDialog] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const dispatch = useDispatch();
	const site = useSelector((state) => state.auth.site);

	const handleClose = () => {
		if (!isSubmitting) {
			setShowDialog(false);
		}
	};

	const handleCreate = async (folderName) => {
		if (!site) return;
		setIsSubmitting(true);
		try {
			await dispatch(createNewFolder({ site, name: folderName }));
			setShowDialog(false);
		} catch (_err) {
			alert(
				"Something went wrong while creating the folder. Please try again.",
			);
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<>
			<Button
				buttonType="primary"
				isActive
				onClick={() => setShowDialog(true)}
				leftIcon="folder"
			>
				Create folder
			</Button>
			<NodeNameDialog
				isOpen={showDialog}
				title="Create new folder"
				confirmLabel="Create"
				initialName=""
				isSubmitting={isSubmitting}
				onConfirm={handleCreate}
				onClose={handleClose}
			/>
		</>
	);
}
